
import DrDocWeb from "./drdocweb.js";
// --
// Constructor Function
export default function Dataset(obj) {
	//return obj;
	// obj { ID, Dataset:{Value} }
	if (!Dataset.IsDataset(obj)) {
		// => kein IDataset Model
		console.warn('Dataset: kein Model Type! ' + obj);
		return obj;
	}
	var id = Dataset.GetID(obj); // obj[Dataset.ID_FIELD] !== undefined ? obj[Dataset.ID_FIELD] : 0;
	//var thisObj = null;
	var newObj = obj;
	// Namespace.ClassName, AssemblyName => Namespace.ClassName
	/*if (obj.$ModelType == undefined) {
		if (obj.$type === undefined) {
			//console.warn(obj);
		} else
			obj.$ModelType = obj.$type.indexOf(',') === -1 ? obj.$type : obj.$type.substr(0, obj.$type.indexOf(','));
	}*/
	//console.log('Model-Name: ' + obj.$ModelType);
	// Namespace.ClassName => ClassName
	/*if (obj.$ClassName == undefined && obj.$ModelType != undefined) {
		obj.$ClassName = obj.$ModelType.lastIndexOf('.') === -1 ? obj.$ModelType : obj.$ModelType.substr(obj.$ModelType.lastIndexOf('.') + 1);
	}**/
	//console.log('Class-Name: ' + obj.$ClassName);
	// Dataset Singleton Check
	obj.$id = undefined;
	if (id != undefined && id > 0 && Dataset.CacheExists(obj)) {
		// Datensatz-ID existiert
		// Wenn obj aktueller ist, als das gespeicherte Object (checksum?), dann Daten kopieren
		//var model_obj = Dataset.Model[obj.$ModelType][id];
		//return model_obj.$Dataset;
		/*if (model_obj === obj) // => Object-Referenz ist identisch
			return model_obj.$Dataset;
		DrDocWeb.CloneCopyTo(obj, model_obj, ['prototype', '__proto__', '$setIDatasetProperties']);
		model_obj.$setIDatasetProperties = undefined;
		setIDatasetProperties(model_obj);
		return model_obj.$Dataset;*/

		//DrDocWeb.CloneCopyTo(obj, Dataset.Model[obj.$ModelType][id], ['prototype', '__proto__', '__ob__', '$id', '$type', '$Username', '$Emitter']);
		//obj = Dataset.Model[obj.$ModelType][id];
		//console.log('DS: ', obj);
	}
	else {
		var customInstance = Dataset.InvokeCtor(obj.$ModelType); //obj.$ClassName);
		if (customInstance !== undefined) {
			//console.log('Call: ' + obj.$ClassName);
			DrDocWeb.CloneCopyTo(obj, customInstance, ['prototype', '__proto__', '__ob__', '$id', '$Username', '$Emitter', '$Dataset']); //, '$ModelType', '$type', '$id']);
			//Object.assign(customInstance, obj);
			obj = customInstance;
			console.log('Dataset: new ' + obj.$ModelType + '();');
			//console.log(obj);
		} else {
			//console.log('DS: ' + obj.$ClassName);
			// keine Änderungen an obj vornehmen
			//console.log('Dataset: no ctor found fpr Type "' + obj.$ModelType + '".');
		}

	}
	if (id != undefined && id > 0) {

		// $ModelType setzen
		if (Dataset.Model[obj.$ModelType] == undefined) {
			Dataset.Model[obj.$ModelType] = [];
		}
		if (Dataset.Model[obj.$ModelType][id] == undefined || Dataset.Model[obj.$ModelType][id] == null)
		{
			// Cache Set Dataset
			Dataset.Model[obj.$ModelType][id] = obj;
		}
		else {
			// Cache Merge Dataset (Obj. Identität beibehalten)
			DrDocWeb.CloneCopyTo(obj, Dataset.Model[obj.$ModelType][id], ['prototype', '__proto__', '__ob__', '$id', '$type', '$Username', '$Emitter', '$Dataset']);
			if (Dataset.Model[obj.$ModelType][id].$Dataset != null)
				DrDocWeb.CloneCopyTo(Dataset.Model[obj.$ModelType][id].$Dataset, this);
		}

		obj = Dataset.Model[obj.$ModelType][id];
		//obj.ID = id;

		Dataset.OnDatasetChanged(obj);
	}
	else {
		//Dataset.OnDatasetChanged(obj);
		//thisObj = this;
	}

	// ALT: obj.$Dataset = this;
	// ALT: this.ID = id;
	// ALT: this.Value = obj;
	// ALT: setIDatasetProperties(obj);
	obj.$Dataset = this;
	this.Value = obj;
	this.ID = id;

	// Response von update-field?
	if (newObj.$Username !== undefined && newObj.$Emitter !== undefined && newObj.$Emitter != Dataset.WindowID) {
		let fieldNames = [];
		for (let propName in newObj) {
			if (!propName.startsWith('$') && propName != Dataset.ID_FIELD) {
				fieldNames.push(propName);
				break;
			}
		}
		if (fieldNames != null && fieldNames.length > 0) {
			if (this.UpdateInfos === undefined) {
				this.UpdateInfos = [];
				console.log('Push Update Info: ', 'new UpdateInfos();');
			}
			this.UpdateInfos.push({
				Username: newObj.$Username,
				Date: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString(),
				FieldNames: fieldNames
			});
			//obj.$Username = undefined;
			//obj.$Emitter = undefined;
			//console.log('Push Update Info: ', this, newObj);
		}
		else
			console.log('Push Update Info: ', 'empty fieldName');
	}

	/*this.SetPropsGetValue = function()
	{
		setIDatasetProperties(obj);
		return obj;
	};*/
	// Funktionen:
	// - Remove
	// - Update
	this.Store = function (successCallback, errorCallback, finallyCallback) {
		return Dataset.Crud({
			usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
			archive: obj.$ModelType,
			model: obj.$ModelType,
			action: 'set',
			value: Dataset.ValueDecode(this.Value),
			id: id, // this.ID //id
			id_field: Dataset.ID_FIELD,
		}, successCallback, errorCallback, finallyCallback);
		//obj.UpdateInternal(refObj);
	};
	// 1. Datensatz Remove-Anfrage an den Server
	// 2. statisches Object _datasets[archiveName][id] löschen
	// 3. Object aus allen refListObj löschen
	this.Remove = function (successCallback, errorCallback, finallyCallback) {
		return Dataset.Crud({
			usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
			archive: obj.$ModelType,
			model: obj.$ModelType,
			action: 'remove',
			id: id, // this.ID //id
			id_field: Dataset.ID_FIELD,
		}, successCallback, errorCallback, function () {
			//obj.RemoveInternal();
			Dataset.Remove(obj.$ModelType, id);
			if (finallyCallback) finallyCallback();
		});
	};
	/*this.RemoveInternal = function()
	{
		Dataset.Remove(this.$ModelType, this.ID);
	};*/
	this.CopyTo = function (targetObj) {
		for (var i in this) targetObj[i] = this[i];
	};
	this.Call = function (methodName, inputObj, storeAfterCall, successCallback, errorCallback) {
		return Dataset.Crud({
			usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
			archive: obj.$ModelType,
			model: obj.$ModelType,
			action: 'call',
			method: methodName,
			id: id, //this.ID,
			id_field: Dataset.ID_FIELD,
			input: inputObj,
			store: storeAfterCall
		}, successCallback, errorCallback, undefined);
	};
	this.Refresh = function (successCallback, errorCallback) {
		return Dataset.Crud({
			usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
			archive: obj.$ModelType,
			model: obj.$ModelType,
			action: 'get',
			id: id, //this.ID
			id_field: Dataset.ID_FIELD,
		}, (succ_obj) => {
			this.Value = succ_obj;
			successCallback(succ_obj);
		}, errorCallback, undefined);
	};
	this.Unlock = function (successCallback, errorCallback) {
		return Dataset.Crud({
			usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
			archive: obj.$ModelType,
			model: obj.$ModelType,
			action: 'unlock',
			id: id, //this.ID
			id_field: Dataset.ID_FIELD,
		}, (succ_obj) => {
			this.Value = succ_obj;
			successCallback(succ_obj);
		}, errorCallback, undefined);
	};
	this.SetTableRow = function (fieldName, fieldValue, forceAppend, save, lineFormat) {
		let ret = false;
		let value_tmp = Dataset.ValueDecode(this.Value);
		//let fieldValueArray = lineFormat === true ? Dataset.GetLineArr(this.Value[fieldName]) : Dataset.GetTableRows(this.Value[fieldName]);
		let fieldValueArray = Dataset.GetTableRows(value_tmp[fieldName]);
		if (!DrDocWeb.IsNullOrEmpty(fieldValue)) {
			let fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());
			if (forceAppend === true || fieldValueIndex === -1) {
				fieldValueArray.push(fieldValue);
				ret = true;

				//console.log('Dataset.SetTableRow: ', typeof fieldValue, fieldValue, fieldValueArray);
				//ret = false;
			}
		}
		if (ret) {
			//this.Value[fieldName] = lineFormat === true ? Dataset.SetLineArr(fieldValueArray) : Dataset.SetTableRows(fieldValueArray);
			value_tmp[fieldName] = Dataset.SetTableRows(fieldValueArray);
			this.Value = Dataset.ValueEncode(value_tmp);
			if (save === undefined || save === true)
			return this.Store();
		}
		return ret;
	};
	this.RemoveTableRow = function (fieldName, fieldValue, save, lineFormat) {
		let ret = false;
		let value_tmp = Dataset.ValueDecode(this.Value);
		//let fieldValueArray = lineFormat === true ? Dataset.GetLineArr(this.Value[fieldName]) : Dataset.GetTableRows(this.Value[fieldName]);
		let fieldValueArray = Dataset.GetTableRows(value_tmp[fieldName]);
		if (!DrDocWeb.IsNullOrEmpty(fieldValue)) {
			let fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());
			// alle Werte entfernen
			while (fieldValueIndex !== -1) {
				fieldValueArray.splice(fieldValueIndex, 1);
				ret = true;
				fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());

				//console.log('Dataset.RemoveTableRow: ', typeof fieldValue, fieldValue, fieldValueArray);
			}
		}
		if (ret) {
			//this.Value[fieldName] = lineFormat === true ? Dataset.SetLineArr(fieldValueArray) : Dataset.SetTableRows(fieldValueArray);
			value_tmp[fieldName] = Dataset.SetTableRows(fieldValueArray);
			this.Value = Dataset.ValueEncode(value_tmp);
			if (save === undefined || save === true)
			return this.Store();
		}
		return ret;
	};

	if (obj.Init !== undefined && typeof obj.Init === 'function') {
		//console.warn('init');
		obj.Init();
	}

	return this;
};

// --
// Statische Funktionen/Member
// Singleton Data
Dataset.ID_FIELD = 'Dokument-Nr.';
Dataset.WindowID = Math.random().toString(36).substring(2, 9);
Dataset.Model = [];
//Dataset.ServerHost = document.location.protocol + '//' + document.location.hostname;
//Dataset.ServerPort = document.location.port;
//Dataset.ServerHost = 'http://127.0.0.1';
//Dataset.ServerPort = '8080';
Dataset.DEBUG = true;
Dataset.DefaultError = null;
Dataset.Ctors = {};
Dataset.ListenState = null;

// --
// Model Constructors
Dataset.AddCtor = function (archiveName, ctor) {
	//Dataset.Ctors[ctor.prototype.constructor.name] = ctor;
	Dataset.Ctors[archiveName] = ctor;
};
Dataset.HasCtor = function (ctorName) //args?
{
	return Dataset.Ctors[ctorName] !== undefined;
};
Dataset.InvokeCtor = function (ctorName) //args?
{
	/*var i = Dataset.Ctors.indexOf(ctor);
	if ( === -1)
	{
		Dataset.Ctors.push(ctor);
	}*/
	return Dataset.Ctors[ctorName] === undefined ? undefined : new Dataset.Ctors[ctorName]();
};

// --

Dataset.GetTableRows = function (fieldValue) {
	if (DrDocWeb.IsNullOrEmpty(fieldValue))
		return [];
	else
		return fieldValue.split(String.fromCharCode(1));
};
Dataset.SetTableRows = function (array) {
	if (array != undefined && array != null && array.length > 0)
		return array.join(String.fromCharCode(1));
	else
		return '';
};
Dataset.GetLineArr = function (fieldValue) {
	if (DrDocWeb.IsNullOrEmpty(fieldValue))
		return [];
	else
		return fieldValue.replaceAll("\r", "").split("\n");
};
Dataset.SetLineArr = function (array) {
	if (array != undefined && array != null && array.length > 0)
		return array.join("\r\n");
	else
		return '';
};

Dataset.IsDataset = function (obj) {
	//if (obj == null && obj.$ModelType == undefined)
	//	return false;
	if (obj == null)
		return false;
	if (obj.$ModelType == undefined)
		return false;
	if (typeof obj == "object")
		return true;
	//if (typeof obj == "dataset")
	//	return true;
	return false;
	//return (obj != null && obj.$type != undefined && ((typeof obj === "object") || (typeof obj === "dataset")));
	//return (obj != null && obj.$type !== undefined && (typeof obj === "object" || typeof obj === "dataset"));
	//return (obj != null && obj.ID !== undefined && obj.$type !== undefined && (typeof obj === "object" || typeof obj === "dataset"));
};

// --
// Crud
/*
Dataset.GetDataRaw = function (url, paramsObj, loadEvent, errorCallback) {
	let onErrorEvent = function (e) {
		let responseObject = {
			Error: {
				Message: 'Verbindungsfehler',
				Error: 'Verbindungsfehler',
				InternalMessage: 'Verbindungsfehler'
			}
		};
		if (errorCallback != null)
			errorCallback(e); //responseObject.Error);
		else if (Dataset.DefaultError != null)
			Dataset.DefaultError(e); //responseObject.Error); //, event.target.status);
		//else
		//	alert(responseObject.Error.Message + '\n\n' + responseObject.Error.InternalMessage);

		console.error('Verbindungsfehler', e);
	};

	if (Dataset.WindowID == undefined || Dataset.WindowID == null)
		Dataset.WindowID = Math.random().toString(36).substring(2, 9) + '-';
	if (paramsObj == null) {
		paramsObj = { emitter: Dataset.WindowID };
	}
	else {
		paramsObj.emitter = Dataset.WindowID;
	}
	// ToDo:
	// statt Callback Promise verwenden
	var requestUrl = Dataset.ServerHost + ':' + Dataset.ServerPort + url;
	var request = new XMLHttpRequest();
	request.open('POST', requestUrl);
	request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	request.addEventListener('load', loadEvent);
	request.addEventListener('error', onErrorEvent);
	request.addEventListener('abort', onErrorEvent);
	request.send(Dataset.ObjectToQueryStr(paramsObj));
};*/

// Crud
Dataset.GetDataRaw = function (url, paramsObj) {
	if (Dataset.WindowID == undefined || Dataset.WindowID == null)
		Dataset.WindowID = Math.random().toString(36).substring(2, 9) + '-';
	if (paramsObj == null) {
		paramsObj = { emitter: Dataset.WindowID };
	}
	else {
		paramsObj.emitter = Dataset.WindowID;
	}

	let getStr = Dataset.ObjectToQueryStr(paramsObj);
	return DrDocWeb.Send('GET', url, getStr, undefined, 'json', '', '', true);
};

Dataset.GetData = function (url, paramsObj, successCallback, errorCallback, finallyCallback) {
	var loadEvent = function (responseObject) {
		return new Promise(function (resolve, reject) {
			//console.log(event);

			/*var responseObject = null;
			if (event.target.getResponseHeader('Content-Type').indexOf('text/json') !== 0) {
				responseObject = {
					HasError: true,
					Result: null,
					Error: {
						Message: 'Der Server hat eine ungültige Antwort geliefert:\n' + event.target.responseText,
						InternalMessage: event.target.responseText
					}
				};
			} else {
				try {
					//responseObject = resolveReferences(JSON.parse(request.responseText));
					//console.warn(responseObject);
					//responseObject = DrDocWeb.JsonRetrocycle(JSON.parse(event.target.responseText));
					responseObject = DrDocWeb.JsonParse(event.target.responseText);
					if (responseObject == null) {
						responseObject = {
							HasError: false,
							Result: null,
							Error: null
						};
					}
					//if (responseObject.$id !== undefined || responseObject.$ref !== undefined || responseObject.$values !== undefined) //console.warn(responseObject);
				} catch (e) {
					console.error('Dataset Deserialize', e);
					responseObject = {
						HasError: true,
						Result: null,
						Error: {
							Message: 'Fehler',
							InternalMessage: event.target.responseText
						}
					};
					if (errorCallback != null)
						errorCallback(e);
					else if (Dataset.DefaultError != null)
						Dataset.DefaultError(e);
				}
			}*/

			// $ModelType setzen
			try {
				if (responseObject.$ModelType === undefined) {
					responseObject.$ModelType = paramsObj.archive;
				}
				if (responseObject.$ModelType !== undefined) {

					if (responseObject.Result != null && responseObject.Result instanceof Array) {
						for (var i in responseObject.Result) {
							if (typeof responseObject.Result[i] !== 'string' && typeof responseObject.Result[i] !== 'boolean' && responseObject.Result[i].$ModelType === undefined)
								responseObject.Result[i].$ModelType = responseObject.$ModelType;
						}
					}
					else if (typeof responseObject.Result !== 'string' && typeof responseObject.Result !== 'boolean' && responseObject.Result !== undefined && responseObject.Result.$ModelType === undefined)
						responseObject.Result.$ModelType = responseObject.$ModelType;

				}
			} catch (x) {

			}

			//console.log(responseObject);
			if (responseObject.HasError === false) // && request.status >= 200 && request.status < 300)
			{
				// kein Fehler im Response
				var data_obj = null;
				var data_arr = null;

				if (responseObject.Result != null) {
					if (responseObject.Result instanceof Array) {
						// Result ist ein Array
						data_arr = [];
						Dataset.TargetArrays.Add(data_arr);
						for (var arri in responseObject.Result) {
							if (responseObject.Result[arri].$ModelType === undefined)
								data_arr[arri] = responseObject.Result[arri];
							else
								data_arr[arri] = new Dataset(responseObject.Result[arri]).Value;
							data_arr[arri] = Dataset.ValueEncode(data_arr[arri]);
						}
					} else {
						// Result ist ein Objekt
						// obj-Objekt-Referenz erhalten
						if (data_obj == null) {
							if (responseObject.Result.$ModelType === undefined)
								data_obj = responseObject.Result;
							else
								data_obj = new Dataset(responseObject.Result).Value;
						}
						else
							DrDocWeb.CloneCopyTo(responseObject.Result, data_obj);
						data_obj = Dataset.ValueEncode(data_obj);
					}
				}

				if (resolve != undefined && resolve != null) {
					resolve(data_arr ? data_arr : data_obj);
				}
				if (successCallback != undefined && successCallback != null) {
					var metaObj = {
						SortTree: responseObject.MetaSortTree,
						Count: responseObject.Count,
						CountTotal: responseObject.CountTotal,
					};
					if (data_obj == null && data_arr != null)
						successCallback(data_arr, metaObj);
					else if (data_obj != null && data_arr == null)
						successCallback(data_obj, metaObj);
					else
						successCallback(null, metaObj);
				}
			} else {
				// Fehler im Reponse vorhanden
				if (Dataset.DEBUG) {
					if (responseObject != null && responseObject.HasError && responseObject.Error)
						console.warn(responseObject.Error.Message, responseObject.Error.InternalMessage);
					else
						console.warn(event.target.statusText, event.target.responseText);
				}
				if (reject != undefined && reject != null)
					reject(responseObject.Error);
				if (errorCallback != null)
					errorCallback(responseObject.Error); //, event.target.status);
				else if (Dataset.DefaultError != null)
					Dataset.DefaultError(responseObject.Error); //, event.target.status);
				else
					alert(responseObject.Error.Message + '\n\n' + responseObject.Error.InternalMessage);
			}

			if (finallyCallback != undefined && finallyCallback != null) finallyCallback();

		}); // Promise end

	};
	return Dataset.GetDataRaw(url, paramsObj).catch(errorCallback).then(loadEvent);
};
Dataset.Crud = function (paramsObj, successCallback, errorCallback, finallyCallback)
{
	return Dataset.GetData('/model/crud', paramsObj, successCallback, errorCallback, finallyCallback);
};
/*Dataset.Add = function (obj, successCallback, errorCallback, finallyCallback) {
	return Dataset.Crud({
		archive: obj.$ModelType,
		model: obj.$ModelType,
		action: 'add',
		value: obj
	}, successCallback, errorCallback, finallyCallback);
};*/
Dataset.Add = function (archiveName, obj, preset) //, successCallback, errorCallback, finallyCallback)
{
	return Dataset.Crud({
		usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
		archive: archiveName,
		model: archiveName,
		action: 'add',
		value: Dataset.ValueDecode(obj),
		preset: preset == undefined ? '' : preset
	}); //, successCallback, errorCallback, finallyCallback);
};
Dataset.Get = function (archiveName, id, lock) //, successCallback, errorCallback, finallyCallback)
{
	//var className = archiveName.lastIndexOf('.') === -1 ? archiveName : archiveName.substr(archiveName.lastIndexOf('.') + 1);
	//var obj = Dataset.InvokeCtor(className);
	return Dataset.Crud({
		//usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
		archive: archiveName,
		model: archiveName,
		action: 'get',
		id: id,
		id_field: Dataset.ID_FIELD,
		lock: lock
	}); //, successCallback, errorCallback, finallyCallback);
};

Dataset.Listen = function (callback) {
	/*if (callback != null)
	{
		callback(null, null);
	}*/

	// Dataset.GetData = function (url, paramsObj, successCallback, errorCallback, finallyCallback)
	return Dataset.GetData('/model/cache', { listener: Dataset.WindowID },
		(obj) => {
			//console.warn('MAIN Load', e.target.responseText);
			//console.warn('MAIN Load', e);
			//Vue.set(Dataset.Model[obj.$ModelType], Dataset.GetID(obj), obj);
			if (callback != null) {
				callback(obj, true);
			}
			//Dataset.ListenState = true;
			//Vue.set(Dataset, 'ListenState', true);
			Dataset.Listen(callback);
		},
		(obj) => {
			//Dataset.ListenState = false;
			//Vue.set(Dataset, 'ListenState', false);
			// Bei Fehler, nach einigen Sekunden erneut versuchen.
			setTimeout(() => { Dataset.Listen(callback); }, 1000);

			if (callback != null) {
				callback(null, false);
			}

			console.warn('MAIN Error', obj, callback, false);

			if (Dataset.DefaultError != null)
				Dataset.DefaultError(obj);
		});
};
Dataset.OnDatasetChanged = function (value) {

};
Dataset.ValueEncode = function (value) {
	return value;
};
Dataset.ValueDecode = function (value) {
	return value;
};

Dataset.GetCached = function (archiveName, id) //, successCallback, errorCallback, finallyCallback)
{
	if (Dataset.CacheExistsExt(archiveName, id)) {
		//ds.CopyTo(obj);
		if (successCallback != null) successCallback(Dataset.Model[archiveName][id]);
		if (finallyCallback != null) finallyCallback();
		return Dataset.Model[archiveName][id];
	} else {
		//return null;
		var className = archiveName.lastIndexOf('.') === -1 ? archiveName : archiveName.substr(archiveName.lastIndexOf('.') + 1);
		var obj = Dataset.InvokeCtor(className);
		console.log('Dataset.GetCached: 1 ', '/ CacheExistsExt: false', ' / Archive: ', archiveName, ' / ID: ', id);
		//Dataset.Get(archiveName, id, false);
		Dataset.Get(archiveName, id, false).then(function(result)
		{
			console.log('Dataset.GetCached: 2', '/ CacheExistsExt: false', ' / Archive: ', archiveName, ' / ID: ', id, ' / Result: ', result);
		});
		return obj;
	}
};
Dataset.List = function (archiveName, actionParams) //, successCallback, errorCallback, finallyCallback)
{
	/*console.log('-------');
	console.log(archiveName);
	console.log(obj);
	console.log(actionParamArr);
	console.log(successCallback);
	console.log(errorCallback);
	console.log(finallyCallback);
	console.log('-------');*/
	if (actionParams == undefined || actionParams == null) {
		actionParams = {};
	}
	actionParams.archive = archiveName;
	actionParams.action = 'searchfields';
	if (actionParams.value == undefined || actionParams.value == null) {
		actionParams.value = {
			//'Dokument-Nr.': '*'
		};
		actionParams.value[Dataset.ID_FIELD] = '*';
	}
	return Dataset.Crud(actionParams); //, successCallback, errorCallback, finallyCallback);
};
Dataset.Template = function (archiveName, searchTemplate, actionParams) {
	if (actionParams == undefined || actionParams == null) {
		actionParams = {};
	}
	actionParams.archive = archiveName;
	actionParams.action = 'searchtemplate';
	if (actionParams.value == undefined || actionParams.value == null) {
		actionParams.value = searchTemplate;
	}
	return Dataset.Crud(actionParams); //, successCallback, errorCallback, finallyCallback);
};
Dataset.GetID = function (obj) {
	if (obj == undefined || obj == null)
		return 0;

	//if (obj['DokuNr'] !== undefined)
	//return $event['DokuNr'];

	if (obj[Dataset.ID_FIELD] !== undefined)
		return obj[Dataset.ID_FIELD];

	return 0;
}
Dataset.Tree = function (archiveName) //, successCallback, errorCallback, finallyCallback)
{
	return Dataset.Crud({
		archive: archiveName,
		model: archiveName,
		action: 'tree'
	}); //, successCallback, errorCallback, finallyCallback);
};
Dataset.ExistsQ = function (obj) {
	return (Dataset.Get(obj.$ModelType, obj.ID) != null);
};
Dataset.CacheExists = function (obj) {
	return (Dataset.Model[obj.$ModelType] != undefined && Dataset.Model[obj.$ModelType][Dataset.GetID(obj)] !== undefined);
};
Dataset.CacheExistsExt = function (archiveName, id) {
	return Dataset.Model[archiveName] != undefined && Dataset.Model[archiveName][id] != undefined;
};
Dataset.CacheGet = function (obj) {
	if (Dataset.Model[archiveName] != undefined && Dataset.Model[archiveName][id] != undefined);
};
Dataset.Remove = function (archiveName, id) {
	if (Dataset.Model[archiveName] == undefined || Dataset.Model[archiveName][id] == undefined) return;
	// aus allen List References entfernen
	Dataset.TargetArrays.RemoveObjects(archiveName, id);
	Dataset.Model[archiveName].splice(id, 1);
	delete Dataset.Model[archiveName][id];
};
Dataset.ClearAll = function () {
	Dataset.Model = [];
};
Dataset.Equals = function (ds1, ds2) {
	if (ds1 == null && ds2 == null)
		return true;
	if ((ds1 != null && ds2 == null) || (ds1 == null && ds2 != null))
		return false;
	return (ds1.$ModelType !== undefined && ds2.$ModelType !== undefined && ds1.$ModelType == ds2.$ModelType) && Dataset.GetID(ds1) == Dataset.GetID(ds2);
	//return Dataset.GetID(ds1) == Dataset.GetID(ds2);
};
Dataset.IndexOf = function (list, obj) {
	if (list == null)
		return -1;
	for (var i in list) {
		if (Dataset.Equals(list[i], obj) === true) return i;
	}
	return -1;
}
Dataset.Cmp = Dataset.Equals;
/*function (a, b) {
	if (a == null || b == null) return false;
	else return (a.ID == b.ID && a.$type == b.$type);
};*/
Dataset.TargetArrays = {
	list: [],
	Find: function (action) {
		for (var i in Dataset.TargetArrays.list) {
			if (action(Dataset.TargetArrays.list[i]) === true) return i;
		}
		return -1;
	},
	Add: function (targetArrayToAdd) {
		var index = Dataset.TargetArrays.Find(function (targetArray) {
			return (targetArray == targetArrayToAdd);
		});
		if (index == -1) {
			Dataset.TargetArrays.list.push(targetArrayToAdd);
		}
	},
	Remove: function (targetArrayToRemove) {
		var index = Dataset.TargetArrays.Find(function (targetArray) {
			return (targetArray == targetArrayToRemove);
		});
		if (index >= 0) {
			Dataset.TargetArrays.list.splice(index, 1);
			delete Dataset.TargetArrays.list[index];
		}
	},
	RemoveObjects: function (archiveName, id) {
		Dataset.TargetArrays.Find(function (targetArray) {
			for (var elem_i in targetArray) {
				if (targetArray[elem_i].$ModelType == archiveName && targetArray[elem_i].ID == id) {
					//console.log('RemoveFromTargetArrays');
					targetArray.splice(elem_i, 1);
					delete targetArray[elem_i];
				}
			}
			return false;
		});
	},
	Refresh: function () {
		//console.log('Refresh');
		Dataset.TargetArrays.Find(function (targetArray) {
			targetArray.$refresh();
			return false;
		});
	},
	/*Update: function()
	{
	Dataset.TargetArrays.Find(function(targetArray)
	{
	console.log('UpdateTargetArrays'); = undefined

	//targetArray[index] = Dataset;
	//SetObjectMemberwiseFlat(targetArray[index], Dataset);

	for (var i in Dataset)
	{
	targetArray[index][i] = Dataset[i];
}

console.log(targetArray[index]);
});
},*/
};

// --
// Helpers
function setIDatasetProperties(obj) {
	if (typeof obj === 'object') // && !(obj instanceof Array))
	{
		if (obj.$setIDatasetProperties !== undefined) return;
		else obj.$setIDatasetProperties = true;
		//if (obj.$id !== undefined) delete obj.$id;
	}
	for (var prop in obj) {
		if (obj[prop] == null) { } else if (obj[prop] instanceof Array) {
			/*if (obj[prop].$id !== undefined)
			{
				//obj = DrDocWeb.JsonRetrocycle(obj);
				// aus Gott gegebenen Gründen werden nach dem Deserialisieren nicht alle Referenzen aufgelöst. Daher nochmals:
				obj[prop] = resolveReferences(obj[prop]);
			}*/
			setIDatasetProperties(obj[prop]);
		} else if (Dataset.IsDataset(obj[prop])) // IDataset
		{
			obj[prop] = new Dataset(obj[prop]).Value;
		} else if (typeof obj[prop] === 'object') {
			//delete obj.$id;
			/*if (obj[prop].$id !== undefined)
			{
				//obj = DrDocWeb.JsonRetrocycle(obj);
				// aus Gott gegebenen Gründen werden nach dem Deserialisieren nicht alle Referenzen aufgelöst. Daher nochmals:
				obj[prop] = resolveReferences(obj[prop]);
			}*/
			setIDatasetProperties(obj[prop]);
		}
		//else // => ValueType
		//{}
	}
}

Dataset.ObjectToQueryStr = function (obj) {
	if (obj == null)
		return '';
	var strArr = [];
	for (var p in obj) {
		if (obj.hasOwnProperty(p)) {
			var v = obj[p];
			/*strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? JSON.stringify(JsonResolve(v), function(key, value)
			{
				// => typeof Dataset
				// IDataset / Dataset.IsDataset(value): $ModelType, $ClassName, Dataset
				if (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset') return;
				else return value;
			}) : v));*/
			strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? Dataset.JsonToStr(v) : v));
		}
	}
	var str = strArr.join("&");
	//return (str.length == 0 ? '' : '?' + str);
	return str;
};
Dataset.JsonToStr = function(objToConvert) {
	//var cacheObjs = [];
	//var cacheIDs = [];
	/*var seenObjects = [];

	function detect(obj)
	{
		if (obj && (typeof obj === 'object' || obj instanceof Array))
		{
			if (seenObjects.indexOf(obj) !== -1)
			{
				return true;
			}
			seenObjects.push(obj);
			for (var key in obj)
			{
				if (obj.hasOwnProperty(key) && detect(obj[key]))
				{
					console.log(obj, 'cycle at ' + key);
					return true;
				}
			}
		}
		return false;
	};*/
	//return detect(obj);
	//return JSON.stringify(DrDocWeb.JsonDecycle(objToConvert));
	return JSON.stringify(DrDocWeb.JsonDecycle(objToConvert), function (key, value) {
		//if (detect(value)) console.log(value);
		//if (cacheObjs.length > 4) console.log(cacheObjs);
		// => typeof Dataset
		// IDataset / Dataset.IsDataset(value): $ModelType, $ClassName, Dataset
		// Properties, die mit "_out_" beginnen (z.B. _out_DynamicModel) sollen am nicht deserialisiert werden; die Übertragung wäre sinnlos.
		//if (typeof value === 'object' && (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset' || key.indexOf('_out_') === 0 || key.indexOf('_ignore_') === 0))
		if (typeof value === 'object' && key == 'Dataset')
		{
			// Property "Dataset" ignorieren
			return;
		}
		else if (key.indexOf('__') === 0)
		{
			// Properties ignorieren, die mit "__" anfangen
			return;
		}
		else if ((key.indexOf('_') === 0 && key.endsWith('_') === true) || key.indexOf('_out_') === 0 || key.indexOf('_ignore_') === 0)
		{
			// Properties ignorieren, die mit "_" anfangen und enden, z.B. "_test_"
			return;
		}
		else if (key.indexOf('$') === 0) // && key != '$type' && key != '$ModelType' && key != '$ClassName')
		{
			// Properties ignorieren, die mit "$" beginnen, außer die Property $ModelType
			return;
		}
		else if ((key != '' && key != null) && value != null && typeof value === 'Dataset' && value.ID !== undefined && value.ID !== 0) {
			// key == 'archive' &&
			// Wenn das Model (als Root-Node) gespeichert wird, ist key == ''
			//console.log(key);
			return {
				ID: value.ID,
				$type: value.$type
			};
		} else {
			return value;
		}
	});
};
window.Dataset = Dataset;

//export default Dataset
